import {
  type CountryOption,
  CountryOptionListSchema,
  type CreateStateRequest,
  type StateDetail,
  StateDetailSchema,
  type StateListQuery,
  type StateListResponse,
  StateListResponseSchema,
  type UpdateStateRequest,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

/**
 * State master API. Every response is validated with the shared Zod schema.
 */

export const listStates = async (query: StateListQuery): Promise<StateListResponse> => {
  const { data } = await apiClient.get<unknown>('/states', { params: query });
  return StateListResponseSchema.parse(data);
};

export const getState = async (id: string): Promise<StateDetail> => {
  const { data } = await apiClient.get<unknown>(`/states/${id}`);
  return StateDetailSchema.parse(data);
};

export const createState = async (payload: CreateStateRequest): Promise<StateDetail> => {
  const { data } = await apiClient.post<unknown>('/states', payload);
  return StateDetailSchema.parse(data);
};

export const updateState = async (
  id: string,
  payload: UpdateStateRequest,
): Promise<StateDetail> => {
  const { data } = await apiClient.patch<unknown>(`/states/${id}`, payload);
  return StateDetailSchema.parse(data);
};

export const deleteState = async (id: string): Promise<void> => {
  await apiClient.delete(`/states/${id}`);
};

/** Country picker options (shared with the City Master form). */
export const listCountryOptions = async (): Promise<CountryOption[]> => {
  const { data } = await apiClient.get<unknown>('/countries/options');
  return CountryOptionListSchema.parse(data);
};

export const bulkDeleteStates = async (
  ids: string[],
): Promise<{ updated: number; failed: { id: string; error: string }[] }> => {
  const { data } = await apiClient.post<{
    updated: number;
    failed: { id: string; error: string }[];
  }>('/states/bulk-delete', { ids });
  return data;
};

export const bulkSetStatesStatus = async (
  ids: string[],
  isActive: boolean,
): Promise<{ updated: number; failed: { id: string; error: string }[] }> => {
  const { data } = await apiClient.post<{
    updated: number;
    failed: { id: string; error: string }[];
  }>('/states/bulk-set-status', { ids, isActive });
  return data;
};
